module.exports = __webpack_public_path__ + "static/img/team_advisor_eric.086a6d80.png";